/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { useDispatch, useSelector } from 'react-redux';
import { isEmpty, uniqBy } from 'lodash';
import * as action from '../store/DevelopmentOrder.action';
import { shortenStringWithTooltip, customStylesForTesting, colourWayOptions, shortenString, shortenandHoverString } from '../../../Components/helper';
import HandleExpandedView from './HandleExpandedView';
import ConfirmationPopup from '../../../Components/ModalPopup/ConfirmationPopup';
import CustomTooltip from '../../../Components/Tooltip/CustomTooltip';

const TEST_CODE_MAX_LENGTH = 200;
const TEST_CODE_DISPLAY_TRUNCATE = 20;
const TEST_PRICE_MAX_CHARS = 15;

function sanitizeTestPriceInput(raw) {
  if (raw == null || raw === '') {
    return '';
  }
  const sanitized = String(raw)
    .replace(/[^0-9.]/g, '')
    .replace(/(\..*)\./g, '$1');
  if (!/^\d*\.?\d{0,2}$/.test(sanitized)) {
    return null;
  }
  return sanitized.length > TEST_PRICE_MAX_CHARS ? sanitized.slice(0, TEST_PRICE_MAX_CHARS) : sanitized;
}

function TabelsRows({
  item,
  i,
  onSelectCheckBox,
  selectedIdArray,
  currentIndex,
  savedEdit,
  handleChange,
  type,
  desc,
  handleSelectType,
  addInfo,
  actionButtons,
  handleEdit,
  bomOptions,
  // supplierOptions,
  handleSelectBom,
  handleSelectSupplier,
  handleSelectColour,
  selectedBom,
  selectedSupplier,
  forEditId,
  colourOptions,
  selectedColour,
  hideBom,
  expandGrandTotalChild,
  allDatas,
  copyItem,
  parentIndexes,
  array,
  allTestData,
  setForEditId,
  fromBom,
  TestingDeleteAccess,
  testPrice,
  code,
}) {
  const { t } = useTranslation('common');
  const Id = useParams();
  const devOrderID = Id.devOrderId;
  const ProductTestingData = useSelector((redState) => redState);
  const { UserDetails, BOMConfigDetails, SuppliersDetails, SystemMastersDetails } = ProductTestingData;

  const { isSupplierLoggedIn } = UserDetails;
  const dispatch = useDispatch();
  const { isProductArchived } = BOMConfigDetails;
  const { tier2AndAboveList, tier1List } = SuppliersDetails;
  const [state, setState] = useState('');
  const { testTypeMaster } = SystemMastersDetails;
  const [showConfirmation, setShowConfirmation] = useState(false);

  const dateFormat = 'DD-MMM-YYYY';

  const [addClassname, setAddClassname] = useState([
    {
      classId: '',
      showRed: false,
    },
  ]);
  const [supplierOptions, setSupplierOptions] = useState([]);

  useEffect(() => {
    if (UserDetails?.userRole === 'User') {
      const getSupplierbyRole = async () => {
        const supplierList = await dispatch(action.getUserSuppliers());
        const userSuppliers = supplierList?.suppliers?.filter(Boolean)?.map((item) => {
          return { _id: item?._id, name: item?.companies?.[0]?.supplierName || '' };
        });
        setSupplierOptions([...(userSuppliers || [])]);
      };
      getSupplierbyRole();
    } else {
      const suppArray = [...tier1List, ...tier2AndAboveList].filter(Boolean);
      const upnewArr = uniqBy(suppArray, (e) => e?._id);
      setSupplierOptions([...upnewArr]);
    }
  }, [tier2AndAboveList, tier1List, UserDetails?.userRole]);

  const elseObject = (obj) => {
    if (obj?.testReport && obj?.testReport?.[0] && obj?.testReport?.length === 1) {
      const classColour = moment().isAfter(obj?.testReport?.[0]?.expiryDate, 'seconds');
      if (classColour) {
        setAddClassname((prev) => [...prev, { classId: obj?._id, showRed: classColour }]);
      }
    }
  };

  useEffect(() => {
    allDatas?.forEach((obj) => {
      if (!Array.isArray(obj?.testReport)) {
        if (obj?.testReport && obj?.testReport?.expiryDate) {
          const classColour = moment().isAfter(obj?.testReport?.expiryDate, 'seconds');
          setAddClassname([{ classId: obj?._id, showRed: classColour }]);
        }
      } else {
        elseObject(obj);
      }
    });
  }, [allDatas]);

  const setRowEdit = (itemFOrEdit, indexForEdit) => {
    handleEdit(itemFOrEdit, indexForEdit);
  };

  const tableCode = (ele, index) => {
    return (
      <td
        className={ele?.highlightedKeys?.includes('code') ? 'bg-amber first-fix-col' : 'first-fix-col'}
        onClick={() => hideBom && ele?.expandData?.length === 1 && setRowEdit(ele, index)}
      >
        <div>
          {(currentIndex?.[0] === index && ele?._id === forEditId) || !item?._id ? (
            <>
              <div className="common-input-control mb-0">
                <input
                  name="code"
                  key={index}
                  disabled={savedEdit}
                  className="form-control"
                  value={ele?.code}
                  type="text"
                  maxLength={TEST_CODE_MAX_LENGTH}
                  onChange={(e) => handleChange(e, ele)}
                />
              </div>
              <div className="character-counter">
                {code != null ? String(code).length : String(ele?.code ?? '').length}/{TEST_CODE_MAX_LENGTH}
              </div>
            </>
          ) : (
            <span className={`${ele?.highlightedKeys?.includes('code') && 'highlighted-field-testing'}`}>
              {shortenandHoverString(ele?.code, TEST_CODE_DISPLAY_TRUNCATE)}
            </span>
          )}
        </div>
        {ele?.isEmpty && (ele?.code === null || ele?.code === '') && (
          <label className="text-danger m-0 py-1"> {t('DEVLOPMENT_ORDER.TESTING.TABLE_ROW.ENTER_TEST_CODE')} </label>
        )}
      </td>
    );
  };

  const tableDescription = (ele, index) => {
    return (
      <td
        className={ele?.highlightedKeys?.includes('description') ? 'bg-amber' : ''}
        onClick={() => hideBom && ele?.expandData.length === 1 && setRowEdit(ele, index)}
      >
        <div>
          {(currentIndex[0] === index && ele?._id === forEditId) || !ele?._id ? (
            <>
              <div className="common-input-control mb-0">
                <input
                  name="description"
                  key={index}
                  className="form-control "
                  type="text"
                  maxLength="200"
                  value={ele?.description}
                  onChange={(e) => handleChange(e, ele)}
                />
              </div>
              <div className="character-counter">{desc?.length}/200</div>
            </>
          ) : (
            <span className={`${ele?.highlightedKeys?.includes('description') && 'highlighted-field-testing'}`}>
              {shortenandHoverString(ele?.description, 20)}
            </span>
          )}
        </div>
        {ele?.isEmpty && (ele?.description === null || ele?.description === '') && (
          <label className="text-danger m-0 py-1">{t('DEVLOPMENT_ORDER.TESTING.TABLE_ROW.PLEASE_ENTER_TEST_DESCRIPTION')}</label>
        )}
      </td>
    );
  };

  const checkBox = (ele) => {
    return (
      !isSupplierLoggedIn &&
      !isProductArchived && (
        <td>
          <div className="common-checkbox no-label checkbox-center">
            <input
              onChange={(e) => {
                onSelectCheckBox(e, ele?._id);
              }}
              name={`checks_${ele?._id}`}
              id={`checks_${ele?._id}`}
              type="checkbox"
              checked={selectedIdArray.filter((val) => val === ele?._id).length > 0}
            />
            <label htmlFor={`checks_${ele?._id}`} className="chklabel" />
          </div>
        </td>
      )
    );
  };

  const handleSupplierName = (ele) => {
    return Array.isArray(ele?.supplier) ? ele?.supplier[0]?.name : ele?.supplier?.name;
  };

  const forSupplierName = (ele) => {
    return !ele?.isExpanded && ele?.supplier?.length > 1 ? 'Multiple' : !isEmpty(ele?.supplier) && handleSupplierName(ele);
  };

  const handleSupplier = (ele, index) => {
    const currentItems = allTestData?.find((element) => element?._id === item?._id);
    return (
      <td
        className={currentItems?.highlightedKeys?.includes('supplier') ? 'bg-amber' : ''}
        onClick={() =>
          hideBom && ((!item?.isExpanded && item?.expandData?.length === 1) || (item?.isExpanded && item?.expandData?.length > 1)) && setRowEdit(item, i)
        }
      >
        <div>
          {(currentIndex[0] === index && ele?._id === forEditId) || !ele?._id ? (
            <div className="common-react-select mb-0">
              <Select
                name="selectedSupplier"
                maxMenuHeight={132}
                menuPlacement="top"
                menuPosition="fixed"
                key={index}
                options={supplierOptions}
                getOptionLabel={(option) => `${option?.name}`}
                getOptionValue={(option) => `${option?._id}`}
                value={selectedSupplier}
                styles={customStylesForTesting}
                className="common-select"
                classNamePrefix="common-select"
                onChange={(e) => handleSelectSupplier(e, item)}
                placeholder={t('DEVLOPMENT_ORDER.TESTING.TABLE_ROW.SELECT_SUPLIER')}
                isClearable
              />
            </div>
          ) : (
            <span className={`${currentItems?.highlightedKeys?.includes('supplier') && 'highlighted-field-testing'}`}>{forSupplierName(ele)}</span>
          )}
        </div>
      </td>
    );
  };
  const bomCompWasArr = (ele) => {
    return !ele?.isExpanded && !ele?.bomComponent ? '' : ele?.bomComponent?.referenceCode;
  };
  const ifoneBom = (ele) => {
    return !ele?.bomComponent ? '' : bomCompWasArr(ele);
  };
  const forBom = (ele) => {
    return !ele?.isExpanded && Array.isArray(ele?.bomComponent) && ele?.bomComponent?.length > 1 ? 'Multiple' : ifoneBom(ele);
  };
  const handleBom = (ele, index) => {
    const currentItems = allTestData?.find((element) => element?._id === item?._id);
    return (
      <td className={currentItems?.highlightedKeys?.includes('bomComponent') ? 'bg-amber' : ''}>
        <div>
          {(currentIndex[0] === index && ele?._id === forEditId) || !item?._id ? (
            <div className="common-react-select mb-0">
              <Select
                name="selectedBom"
                maxMenuHeight={132}
                menuPlacement="top"
                menuPosition="fixed"
                key={index}
                options={bomOptions}
                getOptionLabel={(option) => `${option?.referenceCode}-${option?.bomType?.name}`}
                getOptionValue={(option) => `${option?._id}`}
                value={selectedBom}
                styles={customStylesForTesting}
                className="common-select"
                classNamePrefix="common-select"
                onChange={(e) => handleSelectBom(e, item)}
                placeholder={t('DEVLOPMENT_ORDER.TESTING.TABLE_ROW.BOM_COMPONENT')}
                isClearable
              />
            </div>
          ) : (
            <span className={`${currentItems?.highlightedKeys?.includes('bomComponent') && 'highlighted-field-testing'}`}>{forBom(ele)}</span>
          )}
        </div>
      </td>
    );
  };

  const colClicked = () => {
    return hideBom && ((!item?.isExpanded && item?.expandData?.length === 1) || (item?.isExpanded && item?.expandData?.length > 1)) && setRowEdit(item, i);
  };

  const colourWasArr = (ele) => {
    return !ele?.isExpanded && !ele?.colour ? '--' : ele?.colour?.name;
  };

  const ifOneColour = (ele) => {
    return !ele?.colour ? '--' : colourWasArr(ele);
  };

  const forColourName = (ele) => {
    if (!ele?.isExpanded && !ele.colour) {
      return '--';
    }
    if (!ele?.isExpanded && ele.colour && ele?.expandData?.length > 1) {
      return 'Multiple';
    }
    if (!ele?.isExpanded && ele.colour && ele?.expandData?.length === 1) {
      return Array.isArray(ele?.colour) ? ele?.colour[0]?.name : ifOneColour(ele);
    }
  };
  const handleColour = (ele, index) => {
    const currentItems = allTestData.find((element) => element?._id === item?._id);
    return (
      <td className={currentItems?.highlightedKeys?.includes('colour') ? 'bg-amber' : ''}>
        <div>
          {(currentIndex[0] === index && ele?._id === forEditId) || !item?._id ? (
            <div className="common-react-select mb-0">
              <Select
                name="selectedColour"
                maxMenuHeight={132}
                menuPlacement="top"
                menuPosition="fixed"
                key={index}
                options={colourWayOptions(colourOptions)}
                getOptionLabel={(option) => `${option.refName}`}
                getOptionValue={(option) => `${option._id}`}
                value={selectedColour}
                styles={customStylesForTesting}
                className="common-select"
                classNamePrefix="common-select"
                onChange={(e) => handleSelectColour(e, item)}
                placeholder={t('DEVLOPMENT_ORDER.TESTING.TABLE_ROW.COLOUR')}
                isClearable
              />
            </div>
          ) : (
            <span className={`${currentItems?.highlightedKeys?.includes('colour') && 'highlighted-field-testing'}`}>{forColourName(ele)}</span>
          )}
        </div>
      </td>
    );
  };

  const statuSet = (ele) => {
    switch (Array.isArray(ele?.status) ? ele?.status?.[0]?.toString() : ele?.status?.toString()) {
      case 'true':
      case 'Approved':
        return (
          <>
            <span>{t('DEVLOPMENT_ORDER.TESTING.TABLE_ROW.APPROVED')}</span>
            <span className="col-status right approved" />
          </>
        );

      case 'false':
      case 'Rejected':
        return (
          <>
            <span>{t('DEVLOPMENT_ORDER.TESTING.TABLE_ROW.REJECT')}</span>
            <span className="col-status right rejected" />
          </>
        );

      default:
        return (
          <>
            <span>{t('DEVLOPMENT_ORDER.TESTING.TABLE_ROW.PENDING')}</span>
            <span className="col-status right pending" />
          </>
        );
    }
  };

  const statusCalled = (ele) => {
    return ele?.status !== 'pending' || ele?.status !== 'Pending' ? (
      statuSet(ele)
    ) : (
      <>
        <span>{t('DEVLOPMENT_ORDER.TESTING.TABLE_ROW.PENDING')}</span>
        <span className="col-status right pending" />
      </>
    );
  };

  const setStatuSet = (ele) => {
    switch (Array.isArray(ele?.status) ? ele?.status?.[0]?.toString() : ele?.status?.toString()) {
      case 'true':
      case 'Approved':
        return (
          <>
            <span>{t('DEVLOPMENT_ORDER.TESTING.TABLE_ROW.APPROVED')}</span>
            <span className="col-status right approved" />
          </>
        );

      case 'false':
      case 'Rejected':
        return (
          <>
            <span>{t('DEVLOPMENT_ORDER.TESTING.TABLE_ROW.REJECT')}</span>
            <span className="col-status right rejected" />
          </>
        );

      default:
        return (
          <>
            <span>{t('DEVLOPMENT_ORDER.TESTING.TABLE_ROW.PENDINGS')}</span>
            <span className="col-status right pending" />
          </>
        );
    }
  };

  function ArrstatusCalled(ele) {
    return ele?.status?.[0] === 'pending' || ele?.status?.[0] === 'Pending' ? (
      <>
        <span>{t('DEVLOPMENT_ORDER.TESTING.TABLE_ROW.PENDINGS')}</span>
        <span className="col-status right pending" />
      </>
    ) : (
      setStatuSet(ele)
    );
  }

  const statusWasArr = (ele) => {
    return !ele?.isExpanded && ele?.status?.length === 1 ? ArrstatusCalled(ele) : statusCalled(ele);
  };

  const ifoneStatus = (ele) => {
    return isEmpty(ele?.status) || !ele?.status?.[0] ? (
      <>
        <span>{t('DEVLOPMENT_ORDER.TESTING.TABLE_ROW.PENDING_')}</span>
        <span className="col-status right pending" />
      </>
    ) : (
      statusWasArr(ele)
    );
  };

  const forStatus = (ele) => {
    return !ele?.isExpanded && ele?.status?.length > 1 ? '' : ifoneStatus(ele);
  };

  const approveRejWasArr = (ele) => {
    return !ele?.isExpanded && ele?.approveRejectedBy?.length === 1
      ? `${ele?.approveRejectedBy?.[0]?.firstName} ${ele?.approveRejectedBy?.[0]?.lastName} `
      : `${ele?.approveRejectedBy?.firstName} ${ele?.approveRejectedBy?.lastName}`;
  };

  const ifoneAppRej = (ele) => {
    return !ele?.approveRejectedBy || (Array.isArray(ele.approveRejectedBy) && isEmpty(ele.approveRejectedBy)) ? '' : approveRejWasArr(ele);
  };

  const forAppRej = (ele) => {
    return !ele?.isExpanded && ele?.approveRejectedBy?.length > 1 ? '' : ifoneAppRej(ele);
  };
  const selectedDataArr = (ele) => {
    return !ele?.isExpanded && ele?.selectedDate?.length === 1 ? moment(ele?.selectedDate[0]).format(dateFormat) : moment(ele?.selectedDate).format(dateFormat);
  };
  const ifoneAppAt = (ele) => {
    return !ele?.selectedDate || !ele?.selectedDate?.[0] ? '' : selectedDataArr(ele);
  };
  const forCmntApprovedAt = (ele) => {
    return !ele?.isExpanded && ele?.selectedDate?.length > 1 ? '' : ifoneAppAt(ele);
  };

  const setResultData = (resData) => {
    let res = '';
    if (Array.isArray(resData)) {
      res = resData[0];
    } else {
      res = resData || '-';
    }
    return res;
  };
  const setCommentData = (comData) => {
    let res = '';
    if (Array.isArray(comData)) {
      res = comData[0];
    } else {
      res = comData;
    }
    return res;
  };
  const commentPart = (cmnt, cmntindex) => {
    return (
      <div className="position-static">
        {(currentIndex?.length === 1 && currentIndex?.[0] === cmntindex && cmnt?._id === forEditId) || !cmnt?._id ? null : (
          <span>
            {!Array.isArray(cmnt?.status) && statusCalled(cmnt)}
            {Array.isArray(cmnt?.status) && forStatus(cmnt)}

            <OverlayTrigger
              trigger="hover"
              rootClose
              overlay={
                <Popover className="custom-popover modified-popover">
                  <Popover.Content>
                    <p className="mb-1">
                      <span className="text-bold">{t('DEVLOPMENT_ORDER.TESTING.TABLE_ROW.CREATED_BY')}: </span>
                      {Array.isArray(cmnt?.approveRejectedBy) && forAppRej(cmnt)}
                      {!Array.isArray(cmnt?.approveRejectedBy) &&
                        cmnt?.approveRejectedBy &&
                        `${cmnt?.approveRejectedBy?.firstName} ${cmnt?.approveRejectedBy?.lastName}`}
                    </p>
                    <p className="mb-1">
                      <span className="text-bold">{t('DEVLOPMENT_ORDER.TESTING.TABLE_ROW.DATE_TIME')}: </span>
                      {Array.isArray(cmnt.selectedDate) && forCmntApprovedAt(cmnt)}
                      {!Array.isArray(cmnt?.selectedDate) && moment(cmnt.selectedDate).format('DD-MMM-YYYY')}
                    </p>
                    <p className="mb-1">
                      <span className="text-bold">{t('DEVLOPMENT_ORDER.TESTING.TABLE_ROW.RESULT')}: </span>
                      {setCommentData(cmnt?.comment) || '-'}
                    </p>
                    <p className="mb-1">
                      <span className="text-bold">{t('DEVLOPMENT_ORDER.TESTING.TABLE_ROW.COMMENT')}: </span>
                      {setResultData(cmnt?.result) || '-'}
                    </p>
                  </Popover.Content>
                </Popover>
              }
            >
              <p className="text-truncate mt-1 d-block mb-0 line-h-normal">{setResultData(cmnt?.result) || setCommentData(cmnt?.comment)}</p>
            </OverlayTrigger>
          </span>
        )}
      </div>
    );
  };
  const handleComments = (cmnt, cmntindex) => {
    return (
      <td className="increase-z-index last-fix-col" onClick={() => hideBom && cmnt?.expandData?.length === 1 && setRowEdit(cmnt, cmntindex)}>
        {commentPart(cmnt, cmntindex)}
      </td>
    );
  };

  const textClasses = (ele) => {
    let classNames = 'text-success';
    if (!isEmpty(addClassname)) {
      addClassname.forEach((element) => {
        if (element.classId === ele?._id && element.showRed) classNames = 'text-danger';
      });
    }
    return classNames;
  };
  const toDate = (childItem) => {
    return childItem?.testReport?.[0]?.expiryDate ? moment(childItem.testReport[0].expiryDate).format(dateFormat) : '--';
  };

  const toDatealone = (childItem) => {
    return childItem?.testReport?.expiryDate ? moment(childItem.testReport.expiryDate).format(dateFormat) : '--';
  };

  const handleDeleteTR = async (ele) => {
    if (fromBom) {
      setForEditId('');
    }
    setState(ele);
    setShowConfirmation(true);
  };

  const testReportWasArr = (ele) => {
    return !ele?.isExpanded && ele?.testReport?.length === 1 ? (
      <>
        <span>{shortenandHoverString(ele?.testReport?.[0]?.pdfTitle, 20)} | </span>
        <span className={textClasses(ele)}>{toDate(ele)}</span>
        {(TestingDeleteAccess || fromBom) && UserDetails?.userRole !== 'Supplier' && (
          <CustomTooltip placement="top" tooltipText={t('COMMON_LABEL.DELETE')}>
            <button type="button" aria-label="delete" onClick={() => handleDeleteTR(ele)} className="btn" disabled={isProductArchived}>
              <span className="icon-Delete-bold" />
            </button>
          </CustomTooltip>
        )}
      </>
    ) : (
      <>
        <span>{shortenandHoverString(ele?.testReport?.[0]?.pdfTitle, 40)} | </span>
        <span className={textClasses(ele)}>{toDatealone(ele)}</span>
      </>
    );
  };

  const ifOneData = (ele) => {
    return !ele?.testReport?.[0] ? '' : testReportWasArr(ele);
  };

  const forTestReports = (ele) => {
    return !ele?.isExpanded && ele?.testReport?.length > 1 ? '' : ifOneData(ele);
  };

  const handleToggle = () => {
    if (fromBom) {
      setForEditId('');
    }
    setShowConfirmation(false);
    setState('');
  };

  const DeleteReport = async () => {
    const params = { id: devOrderID };
    const deleteParam = { libIds: state?.libId };
    const res = await dispatch(action.deleteTestingReport(deleteParam, devOrderID, state?.testReport?.[0]?._id, t));
    setShowConfirmation(false);
    if (res) {
      await dispatch(action.ProductTesting(params));
      await dispatch(action.fetchReportList({ id: devOrderID }));
      setState('');
      if (fromBom) {
        setForEditId('');
        const getAttributes = {
          pageIndex: 1,
          pageSize: 20,
          devOrderId: devOrderID,
          bomComponent: state.bomComponent._id,
        };
        await dispatch(action.fetchProductBomTesting(getAttributes));
      }
    }
  };

  const handleTestReports = (ele, index) => {
    return (
      <td onClick={() => hideBom && ele?.expandData?.length === 1 && setRowEdit(ele, index)}>
        <div>
          {(currentIndex?.length === 1 && currentIndex?.[0] === index && ele?._id === forEditId) || !ele?._id ? null : <span>{forTestReports(ele)}</span>}
        </div>
      </td>
    );
  };

  const handleAdditionalInfo = (ele, index) => {
    return (
      <td
        className={ele?.highlightedKeys?.includes('additionalInformation') ? 'bg-amber' : ''}
        onClick={() => hideBom && ele?.expandData?.length === 1 && setRowEdit(ele, index)}
      >
        <div>
          {(currentIndex?.[0] === index && ele?._id === forEditId) || !ele?._id ? (
            <>
              <div className="common-input-control mb-0">
                <input
                  name="additionalInformation"
                  key={index}
                  className="form-control"
                  value={ele?.additionalInformation}
                  onChange={(e) => handleChange(e, ele)}
                  type="text"
                  maxLength="400"
                />
              </div>
              <div className="character-counter ng-binding">
                {addInfo?.length}
                /400
              </div>
            </>
          ) : (
            <p className={`${ele?.highlightedKeys?.includes('additionalInformation') && 'highlighted-field-testing'} mb-0`}>
              {shortenandHoverString(ele?.additionalInformation, 20)}{' '}
            </p>
          )}
        </div>
      </td>
    );
  };

  const handleTestPrice = (ele, index) => {
    return (
      <td
        className={ele?.highlightedKeys?.includes('testPrice') ? 'bg-amber' : ''}
        onClick={() => hideBom && ele?.expandData?.length === 1 && setRowEdit(ele, index)}
      >
        <div>
          {(currentIndex?.[0] === index && ele?._id === forEditId) || !ele?._id ? (
            <>
              <div className="common-input-control mb-0">
                <input
                  name="testPrice"
                  key={index}
                  className="form-control"
                  value={ele?.testPrice ?? ''}
                  onChange={(e) => {
                    const next = sanitizeTestPriceInput(e.target.value);
                    if (next === null) {
                      return;
                    }
                    handleChange({ currentTarget: { name: 'testPrice', value: next } }, ele);
                  }}
                  type="text"
                  inputMode="decimal"
                  maxLength={TEST_PRICE_MAX_CHARS}
                />
              </div>
              <div className="character-counter">
                {String(ele?.testPrice ?? '').length}/{TEST_PRICE_MAX_CHARS}
              </div>
            </>
          ) : (
            <p className={`${ele?.highlightedKeys?.includes('testPrice') && 'highlighted-field-testing'} mb-0`}>{ele?.testPrice}</p>
          )}
        </div>
      </td>
    );
  };

  const showMoreCol = () => {
    return (
      <td>
        {item?.expandData &&
          item?.expandData?.length > 1 &&
          (item.isExpanded ? (
            <button className="btn-up-down" aria-label="button" onClick={() => expandGrandTotalChild(i)} type="button">
              <span className="icon-new-down-arrow-icon icon-inverse" />
            </button>
          ) : (
            <button className="btn-up-down" aria-label="button" onClick={() => expandGrandTotalChild(i)} type="button">
              <span className="icon-new-down-arrow-icon" />
            </button>
          ))}
      </td>
    );
  };

  const checkBoxes = () => {
    return item?.expandData?.length === 1 ? checkBox(item) : <td className="w-80px" />;
  };

  const showMinPassRate = (ele, index) => {
    return (
      <td
        className={ele?.highlightedKeys?.includes('minPassRate') ? 'bg-amber ' : ''}
        onClick={() => hideBom && ele?.expandData?.length === 1 && setRowEdit(ele, index)}
      >
        <div>
          {(currentIndex?.[0] === index && ele?._id === forEditId) || !ele?._id ? (
            <div className="common-input-control mb-0">
              <input
                name="minPassRate"
                maxLength="400"
                key={index}
                className="form-control "
                value={ele?.minPassRate}
                onChange={(e) => handleChange(e, ele)}
                type="text"
              />
              <div className="character-counter ng-binding">{ele?.minPassRate?.length || 0}/400</div>
            </div>
          ) : (
            <span className={`${ele?.highlightedKeys?.includes('minPassRate') && 'highlighted-field-testing'}`}>
              {shortenandHoverString(ele?.minPassRate, 20)}
            </span>
          )}
        </div>
        {ele?.isEmpty && (ele?.minPassRate === null || ele?.minPassRate === '') && (
          <label htmlFor="minPassRate" className="text-danger m-0 py-1">
            {t('DEVLOPMENT_ORDER.TESTING.TABLE_ROW.PLEASE_ENTER_MINUM_PASS_RATE')}
          </label>
        )}
      </td>
    );
  };

  const TypeWasArr = (ele) => {
    return (!ele?.isExpanded && testTypeMaster.find((data) => data?._id === ele?.type)?.name) || testTypeMaster.find((data) => data?._id === ele?.type)?.name;
  };

  const ifoneType = (ele) => {
    return !ele?.type?.[0] ? ele?.type?.name : TypeWasArr(ele);
  };

  const forType = (ele) => {
    return !ele?.isExpanded && ele?.expandData?.length > 1 ? 'Multiple' : ifoneType(ele);
  };
  const testTypeOptions = testTypeMaster?.filter((el) => el?.isActive === true);

  const tabRows = () => {
    const currentItems = allTestData?.find((ele) => ele?._id === item?._id);

    const hasSupplierMatch = item?.supplier?.[0]?._id ? supplierOptions?.find((ele) => ele?._id === item?.supplier?.[0]?._id) : true;
    return (
      hasSupplierMatch && (
        <tr key={i}>
          {!isSupplierLoggedIn && !isProductArchived && checkBoxes()}
          {showMoreCol()}
          {tableCode(item, i)}
          {tableDescription(item, i)}

          <td className={currentItems?.highlightedKeys?.includes('type') ? 'bg-amber ' : ''} onClick={() => colClicked()}>
            <div>
              {(currentIndex?.[0] === i && item?._id === forEditId) || !item?._id ? (
                <div className="common-react-select mb-0">
                  <Select
                    name="type"
                    maxMenuHeight={132}
                    menuPlacement="top"
                    menuPosition="fixed"
                    key={i}
                    options={testTypeOptions}
                    getOptionLabel={(option) => `${option?.name}`}
                    getOptionValue={(option) => `${option?._id}`}
                    value={type}
                    styles={customStylesForTesting}
                    className="common-select"
                    classNamePrefix="common-select"
                    onChange={(e) => handleSelectType(e, item)}
                    placeholder={t('DEVLOPMENT_ORDER.TESTING.TABLE_ROW.TEST_TYPES')}
                    isClearable
                  />
                </div>
              ) : (
                <div className={`${currentItems?.highlightedKeys?.includes('type') && 'highlighted-field-testing'}`}>
                  {shortenandHoverString(forType(item), 10)}
                </div>
              )}
            </div>
            {item?.isEmpty && (item?.type === '' || item?.type === null) && (
              <label className="text-danger m-0 py-1">{t('DEVLOPMENT_ORDER.TESTING.TABLE_ROW.TEST_TYPE_REQUIRED')}</label>
            )}
          </td>
          {showMinPassRate(item, i)}
          {handleTestReports(item, i)}
          {handleSupplier(item, i)}
          {!hideBom && handleBom(item, i)}
          {handleColour(item, i)}
          {handleAdditionalInfo(item, i)}
          {handleTestPrice(item, i)}
          {(!hideBom && (item?.expandData?.length === 1 || !item?._id)) || (hideBom && item?.expandData?.length === 1) ? (
            handleComments(item, i)
          ) : (
            <td className="increase-z-index last-fix-col" />
          )}
          <td className="px-1 text-right increase-z-index">
            <div className="table-action-container">{(item?.expandData?.length === 1 || !item?._id) && actionButtons(item, i)}</div>
          </td>
        </tr>
      )
    );
  };

  return (
    <>
      {item?.isExpanded ? (
        <HandleExpandedView
          expandData={item.expandData}
          index={i}
          statusCalled={statusCalled}
          desc={desc}
          code={code}
          tableCode={tableCode}
          currentIndex={currentIndex}
          checkBox={checkBox}
          addInfo={addInfo}
          testPrice={testPrice}
          forEditId={forEditId}
          supplierOptions={supplierOptions}
          selectedSupplier={selectedSupplier}
          handleSelectSupplier={handleSelectSupplier}
          handleSelectBom={handleSelectBom}
          handleSelectType={handleSelectType}
          type={type}
          handleChange={handleChange}
          savedEdit={savedEdit}
          selectedColour={selectedColour}
          colourOptions={colourOptions}
          handleSelectColour={handleSelectColour}
          setRowEdit={setRowEdit}
          hideBom={hideBom}
          bomOptions={bomOptions}
          actionButtons={actionButtons}
          expandGrandTotalChild={expandGrandTotalChild}
          selectedIdArray={selectedIdArray}
          onSelectCheckBox={onSelectCheckBox}
          selectedBom={selectedBom}
          copyItem={copyItem}
          parentIndexes={parentIndexes}
          item={array}
          allData={allTestData}
          setForEditId={setForEditId}
          fromBom={fromBom}
          TestingDeleteAccess={TestingDeleteAccess}
          testTypeMaster={testTypeMaster}
        />
      ) : (
        tabRows()
      )}
      {showConfirmation && (
        <ConfirmationPopup
          onOpen={showConfirmation}
          onConfirm={DeleteReport}
          loading={false}
          title={t('DEVLOPMENT_ORDER.TESTING.TABLE_ROW.REPORT_CONFIRMATION')}
          message={t('DEVLOPMENT_ORDER.TESTING.TABLE_ROW.DELETE_REPORT')}
          toggle={() => handleToggle()}
        />
      )}
    </>
  );
}

export default TabelsRows;
